import { styler, timeline } from 'popmotion'

export default {
    data() {
        return {
            clickable: false
        }
    },

    mounted() {
        const el = this.$el

        let borders = [
            el.querySelector('#border'),
            el.querySelector('#border_2')
        ]
        this.borders = [styler(borders[0]), styler(borders[1])]

        this.borders.map(b => b.set({ pathLength: 0 }))

        this.signUp = styler(el.querySelector('#sign-up-component'))
        this.signUp.set({ opacity: 0 })

        this.topic = styler(el.querySelector('#topic'))

        this.timeline = timeline([
            {
                track: 'border',
                from: { pathLength: 0 },
                to: { pathLength: 100 },
                duration: 600
            },
            0,
            {
                track: 'topic',
                from: { opacity: 1 },
                to: { opacity: 0 }
            },
            {
                track: 'signUp',
                from: { opacity: 0 },
                to: { opacity: 1 }
            }
        ])

        el.addEventListener('mouseenter', this.hover)
        el.addEventListener('mouseleave', this.unhover)

        const signUpButton = this.$el.querySelector('#sign-up-button')
        signUpButton.addEventListener('click', this.openSignUp)
    },

    beforeDestory() {
        this.$el.removeEventListener('mouseenter', this.hover)
        this.$el.removeEventListener('mouseleave', this.unhover)
        this.$el
            .querySelector('#sign-up-button')
            .removeEventListener('click', this.signUpClick)

        this.animation && this.animation.stop()
    },

    methods: {
        hover() {
            this.animation && this.animation.stop()
            this.animation = this.timeline.start({
                update: this.setStyles
            })
            setTimeout(() => (this.clickable = true), 200)
        },

        unhover() {
            this.animation.stop()
            this.animation.reverse()
            this.animation.resume()
            this.clickable = false
        },

        setStyles({ border, signUp, topic }) {
            // console.log(this.ani)
            this.borders.map(b => b.set(border))
            this.signUp.set(signUp)
            this.topic.set(topic)
        },

        openSignUp() {
            if (this.clickable) {
                this.$store.commit('openSignUp', this.name)
            }
        }
    }
}
